import { render, staticRenderFns } from "./app-detail-bk-catalog.vue?vue&type=template&id=7cb4db04&"
import script from "./app-detail-bk-catalog.vue?vue&type=script&lang=js&"
export * from "./app-detail-bk-catalog.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-bk-catalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports